'use strict';

app.filter('progress', function () {
  return function (value, total) {
    return Math.round(value / (total || 1) * 100) + '%';
  };
});
